import React from 'react';
import { Button } from 'reactstrap';
import { useFieldArray } from 'react-hook-form';

export default function({ form, arrayName }) {
  const {
    control,
    register,
    formState: { errors },
  } = form;
  const array = arrayName;
  const contact = useFieldArray({ control, name: `${array}` });

  return (
    <div>
      {contact.fields.map((item, index) => (
        <div key={item.id}>
          <label className="p-3">
            <span className="font-weight-bolder text-left d-block mb-2">Name*</span>
            <input
              className="form-control"
              defaultValue={item.name}
              {...register(`${array}.${index}.name`, { required: 'This is required' })}
            />
            {errors?.[arrayName] && errors?.[arrayName][index]?.name && (
              <div className="text-danger font-weight-bold">
                {errors?.[arrayName][index].name?.message}
              </div>
            )}
          </label>

          <label className="p-3">
            <span className="font-weight-bolder text-left d-block mb-2">Work Phone*</span>
            <input
              className="form-control"
              defaultValue={item.phone}
              {...register(`${array}.${index}.phone`, { required: 'This is required' })}
            />
            {errors?.[arrayName] && errors?.[arrayName][index]?.phone && (
              <div className="text-danger font-weight-bold">
                {errors?.[arrayName][index].phone?.message}
              </div>
            )}
          </label>

          <label className="p-3">
            <span className="font-weight-bolder text-left d-block mb-2">Extention*</span>
            <input
              className="form-control"
              defaultValue={item.ext}
              {...register(`${array}.${index}.ext`)}
            />
            {errors?.[arrayName] && errors?.[arrayName][index]?.ext && (
              <div className="text-danger font-weight-bold">
                {errors?.[arrayName][index].ext?.message}
              </div>
            )}
          </label>

          <label className="p-3">
            <span className="font-weight-bolder text-left d-block mb-2">Email*</span>
            <input
              className="form-control"
              defaultValue={item.email}
              {...register(`${array}.${index}.email`, { required: 'This is required' })}
            />
            {errors?.[arrayName] && errors?.[arrayName][index]?.email && (
              <div className="text-danger font-weight-bold">
                {errors?.[arrayName][index].email?.message}
              </div>
            )}
          </label>

          {contact.fields.length > 1 && (
            <Button type="button" onClick={() => contact.remove(index)}>
              Delete
            </Button>
          )}

          {index + 1 === contact.fields.length && (
            <div className="d-inline-block align-self-end ml-2">
              <Button
                onClick={() => contact.append({})}
                type="button"
                className="mr-2 align-self-bottom"
              >
                Add Contact
              </Button>
            </div>
          )}
        </div>
      ))}

      {contact.fields.length === 0 && (
        <div className="d-inline-block align-self-end ml-2">
          <Button
            onClick={() => contact.append({})}
            type="button"
            className="mr-2 align-self-bottom"
          >
            Add Contact
          </Button>
        </div>
      )}
    </div>
  );
}
